module.exports = __webpack_public_path__ + "img/alert-tip.016ed225.svg";